export default {
  path: "statistics_report/:id?",
  name: "statistics_report",
  meta: {
    label: "Statistic Report",
  },
  props: true,
  component() {
    return import("@/components/StatisticsReport/StatisticsReport.vue");
  },
};
